<section class="project-section-two section-gap">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <!-- Section Title -->
        <div class="section-title text-center">
          <h2 class="title title-tag" *transloco="let t; read: 'home'">
            {{ t("title_project2") }}
          </h2>
        </div>
      </div>
    </div>
    <!-- Project Boxes -->
    <div
      class="row project-boxes mt-80 masonary-layout align-items-center"
      *transloco="let t; read: 'home'"
    >
      <div
        class="col-lg-4 col-md-6"
        *ngFor="let item of portfolio | slice: 0:1"
      >
        <div class="project-box" data-aos="fade-up">
          <div class="project-thumb">
            <div
              class="thumb bg-img-c"
              [style.background-image]="'url(' + item.gridimg + ')'"
            ></div>
          </div>
          <div class="project-desc text-center">
            <div class="section-title">
              <h4>
                <a class="title-tag">{{ t("project_list")[0].title }}</a>
              </h4>
            </div>
            <p>{{ t("project_list")[0].text }}</p>
          </div>
        </div>
      </div>
      <div
        class="col-lg-8 col-md-6"
        *ngFor="let item of portfolio | slice: 1:2"
      >
        <div class="project-box" data-aos="fade-up">
          <div class="project-thumb">
            <div
              class="thumb bg-img-c"
              [style.background-image]="'url(' + item.gridimg + ')'"
            ></div>
          </div>
          <div class="project-desc text-center">
            <div class="section-title">
              <h4>
                <a class="title-tag">{{ t("project_list")[1].title }}</a>
              </h4>
            </div>
            <p>{{ t("project_list")[1].text }}</p>
          </div>
        </div>
      </div>
      <div
        class="col-lg-4 col-md-6 col-12"
        *ngFor="let item of portfolio | slice: 2:5"
      >
        <div class="project-box" data-aos="fade-up">
          <div class="project-thumb">
            <div
              class="thumb bg-img-c"
              [style.background-image]="'url(' + item.gridimg + ')'"
            ></div>
          </div>
          <div class="project-desc text-center">
            <div class="section-title">
              <h4>
                <a class="title-tag">{{
                  t("project_list")[item.id - 1].title
                }}</a>
              </h4>
            </div>
            <p>{{ t("project_list")[item.id - 1].text }}</p>
          </div>
        </div>
      </div>
      <div
        class="col-lg-8 col-md-6"
        *ngFor="let item of portfolio | slice: 5:6"
      >
        <div class="project-box" data-aos="fade-up">
          <div class="project-thumb">
            <div
              class="thumb bg-img-c"
              [style.background-image]="'url(' + item.gridimg + ')'"
            ></div>
          </div>
          <div class="project-desc text-center">
            <div class="section-title">
              <h4>
                <a class="title-tag">{{
                  t("project_list")[item.id - 1].title
                }}</a>
              </h4>
            </div>
            <p>{{ t("project_list")[item.id - 1].text }}</p>
          </div>
        </div>
      </div>
      <div
        class="col-lg-4 col-md-6"
        *ngFor="let item of portfolio | slice: 6:7"
      >
        <div class="project-box" data-aos="fade-up">
          <div class="project-thumb">
            <div
              class="thumb bg-img-c"
              [style.background-image]="'url(' + item.gridimg + ')'"
            ></div>
          </div>
          <div class="project-desc text-center">
            <div class="section-title">
              <h4>
                <a class="title-tag">{{
                  t("project_list")[item.id - 1].title
                }}</a>
              </h4>
            </div>
            <p>{{ t("project_list")[item.id - 1].text }}</p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="view-more-btn text-center mt-50"
      *transloco="let t; read: 'home'"
    >
      <a
        data-aos="fade-up"
        routerLink="/portfolio"
        class="main-btn main-btn-3"
        [routerLink]="['', 'project']"
        >{{ t("button2") }}</a
      >
    </div>
  </div>
</section>
